'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const BreadcrumbsList = forwardRef(function BreadcrumbsList(rest, ref) {
    return jsx("ol", { ref: ref, ...rest });
});

export { BreadcrumbsList };
